import * as React from "react"
import '../grid.css'
import { motion } from "framer-motion"

import { Link } from 'react-router-dom'
import { NavBar } from '../Components/NavBar'

import { Grid, Row, Col } from "react-flexbox-grid"
//adding support for IBM Plex Mono as a font.
import ImageWizehire from '../Assets/Wizehire/Wizehire-big-mockup.png'
import WizehireFinalScreenshot from '../Assets/Wizehire/Wizehire-growth-final.png'
import WizehireOld from '../Assets/Wizehire/Old-dashboard-design.png'
import WizehireLegacyReferral from '../Assets/Wizehire/Legacy-referrals.png'
import "fontsource-jost"

//adding CSS styles inline, as we do
const styles = {
    Page: { backgroundColor: "#27292D" },

    TopTitle: {
        fontFamily: `"IBM Plex Mono", monospace`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "1.25em",
        letterSpacing: "0.0001em",
        lineHeight: 1.2,
        fontWeight: 500,
        fontStyle: "normal",

    } as const,

    HeroDescription: {
        fontFamily: `"Larsseit", sans-serif`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "1.25em",
        letterSpacing: "0.00625em",
        lineHeight: 1.65,

    } as const,

    HeroContainer: {
        width: 424,
        height: 74,
        marginTop: 64,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        overflow: "visible",
        background: "#27292D",
    } as const,


    Style: {
        marginTop: 72,
        width: "100%",
    } as const,

    // styles for text and images, etc. 
    PhotoContainer: {
        maxWidth: "100%",
        maxHeight: "900px",
        overflow: "hidden",
        borderRadius: 4,
        margin: "24px 24px 24px 24px",

    } as const,

    ProjectIntro: {
        fontFamily: `"IBM Plex Mono", monospace`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "2em",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 700,
    },

    OverviewChip: {
        boxSizing: "border-box",
        width: "30%",
        height: 24,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        padding: 16,
        overflow: "hidden",
        backgroundColor: "#343434",
        borderRadius: 4,
        fontFamily: `"Larsseit", sans-serif`,
        color: "#FFF",
        fontSize: "0.9em",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 700,
        fontStyle: "normal",
        textAlign: "center",
        marginBottom: "16px",
    } as const,

    OverviewChipType: {
        boxSizing: "border-box",
        width: "30%",
        height: 24,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        padding: 16,
        overflow: "hidden",
        backgroundColor: "#84AF43",
        borderRadius: 4,
        fontFamily: `"Larsseit", sans-serif`,
        color: "#FFF",
        fontSize: "0.9em",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 700,
        fontStyle: "normal",
        textAlign: "center",
        marginBottom: "16px",
    } as const,
    OverviewChipWrapper: {
        boxSizing: "border-box",
        width: "100%",
        height: 24,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        padding: 16,
        overflow: "visible",
        backgroundColor: "rgba(255, 255, 255,0)",
        borderRadius: 4,
        fontFamily: `"Larsseit", sans-serif`,
        color: "#FFF",
        fontSize: 16,
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 700,
        fontStyle: "normal",
        textAlign: "center",
        marginBottom: "16px",
    } as const,

    OverviewTitle: {
        fontFamily: `"Larsseit", sans-serif`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "1.563rem",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 700,

    } as const,

    OverviewText: {
        fontFamily: `"Larsseit", sans-serif`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "1.25rem",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 400,

    } as const,

    SectionHeader: {
        fontFamily: `"IBM Plex Mono", monospace`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "1.563rem",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 700,
        minWidth: "400px",
    },

    SectionBlurb: {
        fontFamily: `"IBM Plex Mono", monospace`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "1rem",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 400,
        minWidth: "340px",
    },

    SectionTitle: {
        fontFamily: `"Larsseit", sans-serif`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "1.25rem",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 700,

    },

    SectionText: {

    },

    PhotoContainerProject: {
        maxWidth: "100%",
        maxHeight: "900px",
        overflow: "visible",
        margin: "24px 24px 24px 0px"
    } as const,



    ImageCaption: {
        fontFamily: `"Larsseit", sans-serif`,
        color: "rgba(255, 255, 255, 0.6)",
        fontSize: "1.2rem",
        letterSpacing: "0.00625em",
        lineHeight: 1.2,
        fontWeight: 400,
    } as const, 



}


// variants for motion div (TITLE) -

const titleVariants = {
    initial: {
        opacity: 1,
        x: 0,
        fontSize: "3.815em",
    },
    in: {
        opacity: 1,
        x: 0,
        transition: {
            type: "ease",
            ease: [0.22, 1, 0.36, 1],
            duration: 0.75,
            x: { stiffness: 100, velocity: -100 },
        },
        fontSize: "1.563em",
    },
    out: {
        opacity: 1,
        x: "100vw",
    },
}



function CurologyCadence(): JSX.Element {
    return (
        <Grid fluid>
            <Row top="lg">
                <Col lg={6} lgOffset={1}>
                    <motion.div
                        style={styles.Style}
                        initial="initial"
                        animate="in"
                        exit="out"
                        variants={titleVariants}
                    >
                        <p style={styles.TopTitle}>Chaitanya Prashant</p>

                    </motion.div>

                </Col>
                <Col lg={1} lgOffset={2} xs={3} xsOffset={2} style={{ marginTop: 12 }}>
                        <Link to='/'>
                            <NavBar 
                                Active={false}
                            />
                        </Link>
                    </Col>
                    <Col lg={1} xs={4} style={{ marginTop: 12 }}>
                        <Link to='/Pages/About'>
                            <NavBar
                                Active={false}
                                Text="About Me"
                            />

                        </Link>
                    </Col>
            </Row>

            <Row start="lg" style={{marginTop: 64}}>
                <Col xs={12} lgOffset={4}>
                    <motion.div>
                        <p style={styles.ProjectIntro}>Designing for growth at Wizehire</p>
                    </motion.div>
                    <motion.div
                        style={styles.OverviewChipWrapper}
                    >
                        <motion.div
                            style={styles.OverviewChip}
                        >Internship</motion.div>
                        <motion.div
                            style={styles.OverviewChipType}
                        >2019</motion.div>
                    </motion.div>
                </Col>
            </Row>


            <Row start="lg">
                <Col xs={10} lg={6} lgOffset={3}>
                    <motion.div
                    >
                        <img style={styles.PhotoContainer} src={ImageWizehire} alt="Wizehire Dashboard" />
                    </motion.div>

                </Col>
            </Row>



            <Row start="lg">
                <Col xs={10} xsOffset={1} lg={5} lgOffset={1}>
                    <motion.div>
                        <p style={styles.OverviewTitle}>Overview</p>
                        <p style={styles.OverviewText}>Designing a new referral experience within the Wizehire ATS to increase new user growth and aid monetization.</p>
                    </motion.div>
                    <motion.div>
                        <p style={styles.OverviewTitle}>Role</p>
                        <p style={styles.OverviewText}>Lead designer on a cross functional team.</p>
                    </motion.div>
                    <motion.div>
                        <p style={styles.OverviewTitle}>Timeline</p>
                        <p style={styles.OverviewText}>4 weeks</p>
                    </motion.div>

                </Col>
                <Col xs={10} xsOffset={1} lg={5} lgOffset={1}>
                    <motion.div>
                        <p style={styles.OverviewTitle}>Responsibilities</p>
                        <p style={styles.OverviewText}>Design research, interaction and visual design, and product thinking.</p>
                    </motion.div>
                    <motion.div>
                        <p style={styles.OverviewTitle}>Team</p>
                        <ul style={styles.OverviewText}>
                            <li>Chaitanya Prashant - Design</li>
                            <li>Chad Masso - Product and Engineering</li>
                            <li>Ritz Wu - Data</li>
                            <li>Leisha Scallan - Illustrator</li>
                            <li>Olive Krawczyk - Content</li>
                        </ul>
                    </motion.div>
                </Col>

            </Row>

            <Row start="lg" style={{ marginTop: "72px" }}>
                <Col xs={12} lg={2} lgOffset={1}>
                    <motion.div>
                        <p style={styles.SectionHeader}>Introduction</p>
                        <p style={styles.SectionBlurb}>This project was a growth initiative aiming to better allow SMB (small and medium business) owners, who use the Wizehire product for their hiring needs, to invite others facing similar hiring needs in their network. While I co-lead design of the feature, I worked with two product engineers, a writer, and another designer.</p>

                    </motion.div>
                </Col>
                <Col xs={12} lg={6} lgOffset={2}>
                    <motion.div>
                        <p style={styles.HeroDescription}>This project was a growth initiative aiming to better allow SMB (small and medium business) owners, who use the Wizehire product for their hiring needs, to invite others facing similar hiring needs in their network. While I co-lead design of the feature, I worked with two product engineers, a writer, and another designer.</p>
                        <p style={styles.HeroDescription}>As my first design project focused on growth, I realized that while it is important to be informed by metrics and data, one needs to consider the broader user’s journey, instead of paywalls that could serve to be intrusive to the user.</p>
                        <p style={styles.SectionTitle}>Hypothesis</p>
                        <p style={styles.HeroDescription}>If we surface referral options to users at moments of achievement, as well as areas that are discoverable within context, it would allow users to share the value of Wizehire as a product to others within their network, driving new user growth.</p>
                        <motion.div
                            style={styles.PhotoContainerProject}
                        >
                            <img style={styles.PhotoContainerProject} src={WizehireFinalScreenshot} alt="Wizehire Dashboard" />

                            <p style={styles.ImageCaption}>Screengrab of shipped experience from staging</p>

                        </motion.div>
                    </motion.div>
                </Col>
            </Row>
            <Row start="lg" style={{ marginTop: "72px" }}>
                <Col xs={12} lg={2} lgOffset={1}>
                    <motion.div>
                        <p style={styles.SectionHeader}>Understanding the problem</p>
                    </motion.div>

                </Col>
                <Col xs={12} lg={6} lgOffset={2}>
                    <motion.div>
                        <p style={styles.SectionTitle}>Opportunities</p>
                        <p style={styles.HeroDescription}>tl;dr: A very small percentage of promoters (via NPS Score), 13% are responsible for 90% of the referrals from the Wizehire product. There are opportunities to surface invites in a more discoverable way so that users can share the product with other friends + family who have hiring needs, while getting $100 off after each friend signs up.</p>
                        <p style={styles.HeroDescription}>We aimed to validate our hypothesis with promoters first, as they are more likely to refer someone compared to a non promoter.</p>
                        <motion.div
                            style={styles.PhotoContainerProject}
                        >
                            <img style={styles.PhotoContainerProject} src={WizehireFinalScreenshot} alt="Wizehire Dashboard" />

                            <p style={styles.ImageCaption}>Screengrab of shipped experience from staging</p>

                        </motion.div>


                    </motion.div>

                </Col>

            </Row>
            <Row start="lg" style={{ marginTop: "72px" }}>
                <Col xs={12} lg={2} lgOffset={1}>
                    <motion.div>
                        <p style={styles.SectionHeader}>Understanding the problem</p>
                    </motion.div>

                </Col>
                <Col xs={12} lg={6} lgOffset={2}>
                    <motion.div>
                        <p style={styles.SectionTitle}>Opportunities</p>
                        <p style={styles.HeroDescription}>tl;dr: A very small percentage of promoters (via NPS Score), 13% are responsible for 90% of the referrals from the Wizehire product. There are opportunities to surface invites in a more discoverable way so that users can share the product with other friends + family who have hiring needs, while getting $100 off after each friend signs up.</p>
                        <p style={styles.HeroDescription}>We aimed to validate our hypothesis with promoters first, as they are more likely to refer someone compared to a non promoter.</p>
                        <motion.div
                            style={styles.PhotoContainerProject}
                        >
                            <Row>
                                <Col xs = {12} lg={6}>
                                <img style={styles.PhotoContainerProject} src={WizehireLegacyReferral} alt="Wizehire Dashboard" />
                                <p style={styles.ImageCaption}>Screengrab of shipped experience from staging</p>

                                </Col>
                                <Col xs = {12} lg={6}>
                                <img style={styles.PhotoContainerProject} src={WizehireOld} alt="Wizehire Dashboard" />
                                <p style={styles.ImageCaption}>Screengrab of shipped experience from staging</p>

                                </Col>
                            </Row>


                        </motion.div>


                    </motion.div>

                </Col>

            </Row>



            <Row start="lg" >
                <Col xs={12} lg={5} lgOffset={1}>

                    <p style={styles.HeroDescription}>Go back home</p>

                </Col>
            </Row>
        </Grid>



    )
}

export default CurologyCadence;